import { MarketingSuppressionReason } from "@redotech/redo-model/marketing/marketing-suppression/marketing-suppression-zod-schema";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCustomerSuppressionInfo = {
  name: "getCustomerSuppressionInfo" as const,
  input: z.object({ customerId: z.string() }),
  output: z.object({
    emailSuppressionReasons: z.array(createEnum(MarketingSuppressionReason)),
    smsSuppressionReasons: z.array(createEnum(MarketingSuppressionReason)),
  }),
};
